module.exports = __webpack_public_path__ + "fonts/geograph-web-bold.f883eab4.woff2";